import * as types from "./mutation-types";
import Vue from "vue";

const vm = new Vue();

/*
curl --location --request GET '/trade-ideas/list-v2?account_id' \
--header 'x-cognito-id;' \
--header 'x-api-key;'
*/
export const listTradeIdeas = ({ commit, rootState }) => {
  const { account_id } = rootState.accountTypes.selectedAccount;

  commit(types.SET_LOADING, true);
  commit(types.SET_RESET_TRADE_IDEAS);

  vm.$api
    .get(vm.$endpoint.LIST_TRADE_IDEAS_V2, { params: { account_id } })
    .then(async (response) => {
      const newTradeIdeas = response.data.map((strat) => {
        return {
          ...strat,
          total_pnl: strat.trade_ideas.reduce((acc, ti) => {
            return acc + (ti.to_pnl !== undefined ? ti.to_pnl : 0);
          }, 0),
        };
      });
      await new Promise((resolve) => setTimeout(resolve, 150));
      commit(types.SET_LOADING, false);
      commit(types.SET_TRADE_IDEAS, newTradeIdeas);
    })
    .catch((error) => {
      commit(types.SET_LOADING, false);
      commit(types.SET_TRADE_IDEAS, []);
    });
};

/*
curl --location --request GET '/trade-ideas/list-history?account_id' \
--header 'x-api-key;' \
--header 'x-cognito-id;'
*/
export const listHistoryTradeIdeas = ({ commit, rootState }) => {
  const { account_id } = rootState.accountTypes.selectedAccount;

  commit(types.SET_LOADING, true);
  commit(types.SET_RESET_HISTORY_TRADE_IDEAS);

  vm.$api
    .get(vm.$endpoint.LIST_TRADE_IDEAS_HISTORY, { params: { account_id } })
    .then(async (response) => {
      await new Promise((resolve) => setTimeout(resolve, 150));
      commit(types.SET_LOADING, false);
      commit(types.SET_HISTORY_TRADE_IDEAS, response.data);
    })
    .catch((error) => {
      commit(types.SET_LOADING, false);
      commit(types.SET_HISTORY_TRADE_IDEAS, []);
    });
};

/*
curl --location --request POST '/trade-ideas/auth-strategy/stop' \
--header 'x-api-key;' \
--header 'x-cognito-id;' \
--header 'Content-Type: application/json' \
--data-raw '{
    "auth_strat_id": 0,
    "account_id": 0
}'
*/
export const stopStrategy = ({ rootState }, payload) => {
  const { account_id } = rootState.accountTypes.selectedAccount;
  const { auth_strat_id } = payload;

  const body = {
    auth_strat_id,
    account_id,
  };

  return new Promise(async (resolve, reject) => {
    await vm.$api
      .post(vm.$endpoint.STOP_STRATEGY, body)
      .then(async (response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

/*
curl --location --request POST '/trade-ideas/stop' \
--header 'x-api-key;' \
--header 'x-cognito-id;' \
--header 'Content-Type: application/json' \
--data-raw '{
    "ti_id": 0,
    "auth_strat_id": 0,
    "account_id": 0
}'
*/
export const stopTradeIdea = ({ rootState }, payload) => {
  const { account_id } = rootState.accountTypes.selectedAccount;
  const { auth_strat_id, ti_id } = payload;

  const body = {
    account_id,
    auth_strat_id,
    ti_id,
  };

  return new Promise(async (resolve, reject) => {
    await vm.$api
      .post(vm.$endpoint.STOP_TRADE_IDEA, body)
      .then(async (response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
